<app-admin-header [header]="title" [breadcrumbs]="breadcrumbs"></app-admin-header>
<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<div class="container-fluid v4-bg-img w-100">
    <div class="d-flex justify-content-center">
        <div class="d-flex align-items-center mb-3">
            <i class="pi pi-wrench" style="font-size: 2.5rem"></i>
            <h1 class="mx-2">{{title}}</h1>
        </div>
    </div>

    <div class="w-100 d-center" *ngIf="loading">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>

    <div *ngIf="!loading" class="d-flex justify-content-center">
        <div class="container box-1">
            <div class="row box">
                <div class="col-md-4 col-12">
                    <div class="d-flex align-items-center">
                        <i class="pi pi-user" style="font-size: 1.5rem"></i>
                        <h4 class="mx-2">{{'Contents'|translator}}</h4>
                    </div>
                    <div class="d-flex flex-column align-items-start justify-content-start">
                        <div class="flex align-items-center gap-1">
                            <p-checkbox [(ngModel)]="payload.content.allow" [binary]="true" inputId="ny" />
                            <label class="mx-2" for="ny">{{'show'|translator}}</label>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="d-flex align-items-center">
                        <i class="pi pi-android" style="font-size: 1.5rem"></i>
                        <h4 class="mx-2">{{'Knowledge Library'|translator}}</h4>
                    </div>
                    <div class="flex align-items-center gap-1">
                        <p-checkbox [(ngModel)]="payload.kLibrary.allow" [binary]="true" inputId="ny" />
                        <label class="mx-2" for="ny">{{'show'|translator}}</label>
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="d-flex align-items-center">
                        <i class="pi pi-discord" style="font-size: 1.5rem"></i>
                        <h4 class="mx-2">{{'Navigation page'|translator}}</h4>
                    </div>
                    <div class="d-flex flex-row align-items-start gap-2">
                        <div class="flex align-items-center gap-1">
                            <p-checkbox [(ngModel)]="payload.dataView.allow" [binary]="true" inputId="ny" />
                            <label class="mx-2" for="ny">{{'show'|translator}}</label>
                        </div>
                        <div class="flex align-items-center gap-1">
                            <p-checkbox [(ngModel)]="payload.dataView.allowPrint" [binary]="true" inputId="ny" />
                            <label class="mx-2" for="ny">{{'Print Services'|translator}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box mt-3">
                <div class="row justify-content-center">
                    <div class="col-md-4 col-12 gap-2">
                        <div>
                            <label class="mx-2 info" for="ny">{{'Signed'|translator}}</label>
                            <p-treeSelect [(ngModel)]="payload.content.signedOus" selectionMode="multiple"
                                [metaKeySelection]="false" appendTo="body" class="w-md-20rem w-100"
                                containerStyleClass="w-100" [options]="treeData" placeholder="حدد الوحدة التنظيمية"
                                [filter]="true" [filterInputAutoFocus]="true">
                                <ng-template let-node pTemplate="default">
                                    <div class="d-flex" *ngIf="!!node">
                                        <img *ngIf="checkisImg(node?.data); else elseBlock"
                                            src="{{ staticURL }}{{ node?.data }}" class="img-fluid p-1 tree-img-bg"
                                            style="max-height: 30px; max-width: 30px" />
                                        <ng-template #elseBlock>
                                            <i class="{{ node?.data }} p-2" style="font-size: 1rem"></i>
                                        </ng-template>
                                        <b class="text-nowrap">{{ node?.label }}</b>
                                    </div>
                                </ng-template>
                            </p-treeSelect>
                        </div>
                        <div>
                            <label class="mx-2 info" for="ny">{{'all'|translator}}</label>
                            <p-treeSelect [(ngModel)]="payload.content.allOus" selectionMode="multiple"
                                [metaKeySelection]="false" appendTo="body" class="w-md-20rem w-100"
                                containerStyleClass="w-100" [options]="treeData" placeholder="حدد الوحدة التنظيمية"
                                [filter]="true" [filterInputAutoFocus]="true">
                                <ng-template let-node pTemplate="default">
                                    <div class="d-flex" *ngIf="!!node">
                                        <img *ngIf="checkisImg(node?.data); else elseBlock"
                                            src="{{ staticURL }}{{ node?.data }}" class="img-fluid p-1 tree-img-bg"
                                            style="max-height: 30px; max-width: 30px" />
                                        <ng-template #elseBlock>
                                            <i class="{{ node?.data }} p-2" style="font-size: 1rem"></i>
                                        </ng-template>
                                        <b class="text-nowrap">{{ node?.label }}</b>
                                    </div>
                                </ng-template>
                            </p-treeSelect>
                        </div>
                    </div>
                    <div class="col-md-4 col-12">
                        <div>
                            <label class="mx-2 info" for="ny">{{'all'|translator}}</label>
                            <p-treeSelect appendTo="body" selectionMode="multiple" [metaKeySelection]="false"
                                [(ngModel)]="payload.kLibrary.ou" class="w-md-20rem w-100" containerStyleClass="w-100"
                                [options]="treeData" placeholder="حدد الوحدة التنظيمية" [filter]="true"
                                [filterInputAutoFocus]="true">
                                <ng-template let-node pTemplate="default">
                                    <div class="d-flex" *ngIf="!!node">
                                        <img *ngIf="checkisImg(node?.data); else elseBlock"
                                            src="{{ staticURL }}{{ node?.data }}" class="img-fluid p-1 tree-img-bg"
                                            style="max-height: 30px; max-width: 30px" />
                                        <ng-template #elseBlock>
                                            <i class="{{ node?.data }} p-2" style="font-size: 1rem"></i>
                                        </ng-template>
                                        <b class="text-nowrap">{{ node?.label }}</b>
                                    </div>
                                </ng-template>
                            </p-treeSelect>
                        </div>
                        <div class="d-flex flex-column w-100">
                            <label class="mx-2 info" for="ny">{{'Categories'|translator}}</label>
                            <p-multiSelect [(ngModel)]="payload.kLibrary.categories"
                                [placeholder]="'KL category'|translator" class="w-100" styleClass="w-100"
                                [options]="categories" [appendTo]="'body'" [optionValue]="'_id'" optionLabel="name" />
                        </div>

                    </div>
                    <div class="col-md-4 col-12 gap-2">
                        <div>
                            <label class="mx-2 info" for="ny">{{'Signed'|translator}}</label>
                            <p-treeSelect [(ngModel)]="payload.dataView.signedOus" selectionMode="multiple"
                                [metaKeySelection]="false" appendTo="body" class="w-md-20rem w-100"
                                containerStyleClass="w-100" [options]="treeData" placeholder="حدد الوحدة التنظيمية"
                                [filter]="true" [filterInputAutoFocus]="true">
                                <ng-template let-node pTemplate="default">
                                    <div class="d-flex" *ngIf="!!node">
                                        <img *ngIf="checkisImg(node?.data); else elseBlock"
                                            src="{{ staticURL }}{{ node?.data }}" class="img-fluid p-1 tree-img-bg"
                                            style="max-height: 30px; max-width: 30px" />
                                        <ng-template #elseBlock>
                                            <i class="{{ node?.data }} p-2" style="font-size: 1rem"></i>
                                        </ng-template>
                                        <b class="text-nowrap">{{ node?.label }}</b>
                                    </div>
                                </ng-template>
                            </p-treeSelect>
                        </div>
                        <div>
                            <label class="mx-2 info" for="ny">{{'all'|translator}}</label>
                            <p-treeSelect [(ngModel)]="payload.dataView.allOus" selectionMode="multiple"
                                [metaKeySelection]="false" appendTo="body" class="w-md-20rem w-100"
                                containerStyleClass="w-100" [options]="treeData" placeholder="حدد الوحدة التنظيمية"
                                [filter]="true" [filterInputAutoFocus]="true">
                                <ng-template let-node  pTemplate="default">
                                    <div class="d-flex" *ngIf="!!node">
                                        <img *ngIf="checkisImg(node?.data); else elseBlock"
                                            src="{{ staticURL }}{{ node?.data }}" class="img-fluid p-1 tree-img-bg"
                                            style="max-height: 30px; max-width: 30px" />
                                        <ng-template #elseBlock>
                                            <i class="{{ node?.data }} p-2" style="font-size: 1rem"></i>
                                        </ng-template>
                                        <b class="text-nowrap">{{ node?.label }}</b>
                                    </div>
                                </ng-template>
                            </p-treeSelect>
                        </div>
                    </div>

                    <hr class="hr mt-5">

                    <div class="col-md-4 col-12 gap-2">
                        <div class="d-flex flex-column w-100">
                            <label class="mx-2 info" for="ny">{{'Fields to hide from template'|translator}}</label>
                            <p-multiSelect [(ngModel)]="payload.templateHide.fields"
                                [placeholder]="'Data Fields'|translator" class="w-100" styleClass="w-100"
                                [options]="fields" [appendTo]="'body'" [optionValue]="'_id'" optionLabel="name" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!loading" class="d-flex justify-content-center mt-4">
        <button (click)="onSubmit()" class="v4-btn-every"><i
                class="pi pi-check v4-ml-2"></i>{{'Submit'|translator}}</button>
    </div>
    
</div>

<app-footer></app-footer>